import * as React from 'react';
import { useSelector } from 'react-redux';
import { CircleArrowUp, CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';

import { RootState } from '../../../reducers';
import usePlan from '../../plan/hooks/plan';
import useLimits from '../../plan/hooks/limits';
import { requestStatusType } from '../../../types';

const UpgradeButton = () => {
  const { t } = useTranslation();
  const guardLimits = useLimits();
  const { plan } = useSelector((state: RootState) => state);
  const { upgradeStatus } = plan.subscription;
  const prevStatusRef = React.useRef<requestStatusType>('idle');

  const handleClick = () => {
    guardLimits('generalUpgrade', () => {});
  };

  const { isPlan } = usePlan();
  const upgraded = isPlan(['GROWTH', 'BUSINESS', 'ENTERPRISE']);
  let status = upgradeStatus || 'idle';
  if (
    !upgraded &&
    (['failed', 'succeeded'] as requestStatusType[]).includes(upgradeStatus)
  ) {
    status = 'idle';
  }

  // Show toast when status changes
  React.useEffect(() => {
    if (
      status !== 'idle' &&
      status !== 'succeeded' &&
      status !== prevStatusRef.current
    ) {
      const message = t(`upgrade.tooltips.${status}`);
      if (status === 'failed') {
        toast.error(message);
      } else {
        toast(message);
      }
    }
    prevStatusRef.current = status;
  }, [status, t]);

  if (upgraded) {
    return null;
  }

  // Determine the icon to display based on the status
  const Icon = status === 'succeeded' ? CheckCircle : CircleArrowUp;

  return (
    <Button
      variant="default"
      size="default"
      onClick={handleClick}
      disabled={status === 'pending'}
      className="h-10 px-3"
    >
      <Icon className="mr-1 h-4 w-4" />
      {t(`upgrade.buttons.${status}`).replace(/ /g, '\u00A0')}
    </Button>
  );
};

export default UpgradeButton;
